module.exports = __webpack_public_path__ + "static/media/spinner.c3cd0cd1.gif";